/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WearableConnectionProviderStatusDto
 */
export interface WearableConnectionProviderStatusDto {
    /**
     * 
     * @type {string}
     * @memberof WearableConnectionProviderStatusDto
     */
    providerCode: WearableConnectionProviderStatusDtoProviderCodeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WearableConnectionProviderStatusDto
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof WearableConnectionProviderStatusDto
     */
    permissionStatus: WearableConnectionProviderStatusDtoPermissionStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WearableConnectionProviderStatusDto
     */
    isConnected: boolean;
    /**
     * 
     * @type {Date}
     * @memberof WearableConnectionProviderStatusDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const WearableConnectionProviderStatusDtoProviderCodeEnum = {
    AppleHealthkit: 'apple-healthkit',
    GoogleHealthConnect: 'google-health-connect'
} as const;
export type WearableConnectionProviderStatusDtoProviderCodeEnum = typeof WearableConnectionProviderStatusDtoProviderCodeEnum[keyof typeof WearableConnectionProviderStatusDtoProviderCodeEnum];

/**
 * @export
 */
export const WearableConnectionProviderStatusDtoPermissionStatusEnum = {
    Granted: 'granted',
    Partial: 'partial',
    Denied: 'denied',
    Unknown: 'unknown'
} as const;
export type WearableConnectionProviderStatusDtoPermissionStatusEnum = typeof WearableConnectionProviderStatusDtoPermissionStatusEnum[keyof typeof WearableConnectionProviderStatusDtoPermissionStatusEnum];


/**
 * Check if a given object implements the WearableConnectionProviderStatusDto interface.
 */
export function instanceOfWearableConnectionProviderStatusDto(value: object): value is WearableConnectionProviderStatusDto {
    if (!('providerCode' in value) || value['providerCode'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('permissionStatus' in value) || value['permissionStatus'] === undefined) return false;
    if (!('isConnected' in value) || value['isConnected'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function WearableConnectionProviderStatusDtoFromJSON(json: any): WearableConnectionProviderStatusDto {
    return WearableConnectionProviderStatusDtoFromJSONTyped(json, false);
}

export function WearableConnectionProviderStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WearableConnectionProviderStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'providerCode': json['providerCode'],
        'enabled': json['enabled'],
        'permissionStatus': json['permissionStatus'],
        'isConnected': json['isConnected'],
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function WearableConnectionProviderStatusDtoToJSON(json: any): WearableConnectionProviderStatusDto {
    return WearableConnectionProviderStatusDtoToJSONTyped(json, false);
}

export function WearableConnectionProviderStatusDtoToJSONTyped(value?: WearableConnectionProviderStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'providerCode': value['providerCode'],
        'enabled': value['enabled'],
        'permissionStatus': value['permissionStatus'],
        'isConnected': value['isConnected'],
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

